var map = {
	"./decidim/avatar-multiuser.png": 44619,
	"./decidim/brands/google.svg": 25530,
	"./decidim/cc-badge.png": 1465,
	"./decidim/decidim-logo.svg": 4089,
	"./decidim/default-avatar.svg": 52233,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 37679,
	"./decidim/icons.svg": 54024,
	"./decidim/pattern.png": 89275,
	"./decidim/placeholder-card-g.svg": 70984,
	"./decidim/placeholder-card-l.svg": 82211,
	"./decidim/placeholder.jpg": 64042,
	"./decidim/remixicon.symbol.svg": 49296,
	"./decidim/vendor/leaflet/layers-2x.png": 86505,
	"./decidim/vendor/leaflet/layers.png": 69824,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 42513,
	"./decidim/vendor/leaflet/marker-icon.png": 53176,
	"./decidim/vendor/leaflet/marker-shadow.png": 96519,
	"./decidim/vendor/social-share-button/douban.svg": 86147,
	"./decidim/vendor/social-share-button/email.svg": 1820,
	"./decidim/vendor/social-share-button/facebook.svg": 16680,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 27212,
	"./decidim/vendor/social-share-button/hacker_news.svg": 30704,
	"./decidim/vendor/social-share-button/linkedin.svg": 1754,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 19043,
	"./decidim/vendor/social-share-button/pinterest.svg": 93386,
	"./decidim/vendor/social-share-button/reddit.svg": 45760,
	"./decidim/vendor/social-share-button/telegram.svg": 98981,
	"./decidim/vendor/social-share-button/tumblr.svg": 85762,
	"./decidim/vendor/social-share-button/twitter.svg": 63673,
	"./decidim/vendor/social-share-button/vkontakte.svg": 68979,
	"./decidim/vendor/social-share-button/wechat.svg": 34942,
	"./decidim/vendor/social-share-button/whatsapp.svg": 7254,
	"./decidim/vendor/social-share-button/x.svg": 66996,
	"./decidim/vendor/social-share-button/xing.svg": 13028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25806;